export const flickrBadgeWidgetMetaData = {
    isRepeatable: false
}
